import Vue from 'vue';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component
class ModalNotificationModalComponent extends Vue {

  @Prop({ default: false, type: [Boolean] })
  value: boolean;

  @Prop({ default: null, required: false, type: [String] })
  title: string;

  @Prop({ default: null, required: true, type: [String] })
  message: string;

  get vModel(): boolean {
    return this.value;
  }
  set vModel(value: boolean) {
    this.$emit('input', value);
  }


  @Emit('close')
  handleClose() {
    this.vModel = false;
  }

  @Emit('confirm')
  handleConfirm() {
  }
}

export default ModalNotificationModalComponent;


// WEBPACK FOOTER //
// ./src/components/modal-notification/index.ts